import React from "react";
import { Leaf, Truck, ShieldCheck, Wallet } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function WhyJoinFreshMart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const benefits = [{
    title: "Human-Like NLP",
    description: "Our voice agents utilize advanced neural networks to deliver fluid, context-aware conversations that feel indistinguishable from human interaction.",
    icon: Leaf
  }, {
    title: "Infinite Scalability",
    description: "Handle thousands of concurrent calls without latency or quality degradation, ensuring your business never misses a revenue-generating opportunity.",
    icon: Truck
  }, {
    title: "Operational Excellence",
    description: "Drastically reduce overhead while increasing throughput. Our AI works 24/7 without breaks, providing consistent performance at a fraction of the cost.",
    icon: Wallet
  }, {
    title: "Secure Compliance",
    description: "Built with enterprise-level security protocols and end-to-end encryption, we ensure your sensitive business data and customer privacy are protected.",
    icon: ShieldCheck
  }];
  return <section data-section-id="22110" id="why-choose-mollycallai" className="bg-[#111113] py-12 md:py-24 text-foreground">
      <div className="container mx-auto px-4">
        <div ref={ref} className={cn("mx-auto max-w-lg transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <div className="mb-10 text-center md:text-left">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Why Choose MollyCall.ai?
            </h2>
            <p className="mt-4 text-lg font-light text-slate-400">
              Empower your business with next-generation AI voice agents that handle calls with human-like precision and 24/7 availability.
            </p>
          </div>

          <div className="flex flex-col gap-8">
            {benefits.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-5 group p-4 rounded-2xl transition-all duration-300 hover:bg-white/5 border border-transparent hover:border-white/10 backdrop-blur-sm">
                <Badge variant="secondary" className="mt-1 flex size-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary hover:bg-primary/20 transition-all border border-primary/20 shadow-[0_0_15px_rgba(80,70,229,0.1)] group-hover:shadow-[0_0_25px_rgba(80,70,229,0.3)]">
                  <item.icon className="size-6 stroke-[1.5px]" />
                </Badge>
                <div className="space-y-1">
                  <h3 className="text-lg font-bold text-white group-hover:text-primary transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-slate-300 font-light text-lg leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}